import { useTypedQuery } from "hooks";
import { useTyresFilters } from "modules/TyresDashboard/components/TyresDashboardFilters/hooks";
import { TyresDashboardQueryKeys } from "modules/TyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useTyresQuery = () => {
  const filters = useTyresFilters();

  return useTypedQuery({
    queryKey: TyresDashboardQueryKeys.tyres,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, filters, baseUrl)).data,
    refetchOnDependencies: [filters]
  });
};
